import { render, staticRenderFns } from "./EditCourseTeacherCombination.vue?vue&type=template&id=35b04b3f"
import script from "./EditCourseTeacherCombination.vue?vue&type=script&lang=js"
export * from "./EditCourseTeacherCombination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports